import {setScreen} from '../../services/router';
import {strings} from '../../services/language';
import StaffList from './StaffList/StaffList';

export default function PCFStaffListPage() {
  return (
    <>
      <div className="main-header">
        <h1>{strings('PCF Staff')}</h1>
      </div>
      <StaffList />
    </>
  );
}
